{
    "actions": {
        "page": {
            "add_user": "New monetics user"
        },
        "row": {
            "activate": "Reactivate",
            "deactivate": "Deactivate",
            "reset_password": "Send activ. mail",
            "remove": "Remove",
            "connect_as": "Connect as",
            "permissions_update": "Modify permissions",
            "historics_access": "User history"
        }
    },
    "filter": {
        "placeholder": {
            "email": "Filter by email"
        }
    },
    "keys": {
        "status": "Status",
        "email": "Email",
        "profile": "Profile",
        "has_mfa": "2FA",
        "last_login_at": "Connected on",
        "created_at": "Created on",
        "updated_at": "Last updated on"
    },
    "has_mfa": {
        "false": "No",
        "true": "Yes",
        "ENABLED": "Activated",
        "DISABLED": "Deactivated"
    },
    "modal": {
        "send_mail": {
            "title": "New monetics user",
            "emails": "A connection link will be sent by mail",
            "link_validity": "Link is available for the next 72 hours",
            "success": "User created successfully!",
            "maximum_mails": "(5 mails maximum)",
            "placeholder": "Enter email here...",
            "already_exists": "This mail alreay exists !",
            "confirmation": "Mail will be sent to the following recipient:",
            "confirmation_users": "Mail will be sent to the following recipients:",
            "validate": "Validate to finish",
            "add_address": "Add address",
            "remove_address": "Remove address",
            "steps": {
                "set_users": "Step {{step}} on {{maxStep}} : Add emails and profiles",
                "confirmation": "Step {{step}} on {{maxStep}} : ConfirmationStep {{step}} on {{maxStep}} : Select a plan"
            }
        },
        "reset_password": {
            "title": "Reset password",
            "text": "An email will be sent to the following recipient. They will receive a link to reset their password.",
            "warning": "Link is available for the next 72 hours.",
            "success": "An email has been sent to the following address : {{userEmail}}",
            "error": "An error has occured."
        },
        "remove_user": {
            "title": "Remove user",
            "text": "You are about to remove this user.",
            "warning": "Please confirm removal.",
            "success": "User {{userEmail}} has been removed.",
            "error": "An error has occured."
        },
        "permissions_update": {
            "title": "Modify permissions",
            "profile": "Profile",
            "permissions": "Permissions ({{number}})",
            "reset": "Reset profile permissions",
            "show_all": "Show all",
            "success": "Permissions updated successfully !",
            "error": "An error occurred while updating permissions."
        }
    },
    "permissions": {
        "title": "Permissions",
        "module": {
            "SUBSCRIPTION": "Subscription",
            "CONTRACTS_ACCESS": "Merchant account",
            "MERCHANT_CONTRACT": "Contracts",
            "EXPORT": "Exports",
            "SUBSCRIPTION_PLAN": "Plans",
            "ORGANIZATION": "Organizations",
            "PAYMENT": "Remote collection",
            "SIM": "SIM Cards",
            "POS_TERMINAL": "POS terminals",
            "USER": "Users",
            "ENVELOPES": "Envelopes",
            "PUSH_PAYMENT": "Push Payment API",
            "REMOTE_COLLECTIONS": "Remote collections",
            "TRANSACTIONS": "Transactions",
            "SETTINGS": "Settings",
            "HYBRID": "Module “HYBRID”",
            "HISTORICS": "Historics"
        },
        "SUBSCRIPTION_READ": "Read details",
        "SUBSCRIPTION_LIST": "List",
        "SUBSCRIPTION_CONNECTION_POINTS_READ": "List connection points (blocking)",
        "SUBSCRIPTION_CREATE": "Create manually",
        "SUBSCRIPTION_ACTIVATE": "Activate",
        "SUBSCRIPTION_MIGRATE": "Shift billing date",
        "SUBSCRIPTION_TERMINATE": "Terminate",
        "SUBSCRIPTION_REWAREHOUSE": "Rewarehouse",
        "SUBSCRIPTION_UPDATE": "Update",
        "MODIFY_IP_OFFER": "Modify IP offer",
        "BLACKLIST_ADD_ENTRY": "Block POS terminals",
        "BLACKLIST_REMOVE_ENTRY": "Unblock a POS terminal",
        "CONTRACTS_ACCESS_LIST": "List",
        "CONTRACTS_ACCESS_READ": "Read details",
        "CONTRACTS_ACCESS_CREATE": "Create merchant contracts",
        "CONTRACTS_ACCESS_CREATE_CONTRACT_PROFILE": "Assign contracts",
        "CONTRACTS_ACCESS_CREATE_USER": "Add a user",
        "CONTRACTS_ACCESS_ACTIVATE": "Activate",
        "CONTRACTS_ACCESS_DEACTIVATE": "Deactivate",
        "CONTRACTS_ACCESS_UPDATE_CONTRACT_PROFILE": "Update contract label",
        "CONTRACTS_ACCESS_UPDATE": "Update merchant account label",
        "CONTRACTS_ACCESS_DELETE_CONTRACT_PROFILE": "Delete a contract",
        "CSV_ADD_CONTRACTS_ACCESS": "Create merchant accounts using a CSV file",
        "ALMA_ENTER_API_KEY": "Add Alma API key",
        "MERCHANT_CONTRACT_READ": "Read details",
        "MERCHANT_CONTRACT_LIST": "List contracts from a POS terminal",
        "MERCHANT_CONTRACT_LIST_FROM_DIRECT_PROVIDER": "List contracts from the whole POS terminal estate",
        "MERCHANT_CONTRACT_LIST_FROM_PROVIDER": "List",
        "MERCHANT_CONTRACT_CREATE": "Create manually",
        "MERCHANT_CONTRACT_UPDATE": "Update label",
        "CSV_ADD_CONTRACT_PROFILE": "Adding contracts by CSV file",
        "MERCHANT_CONTRACT_EXPORT": "Export contracts",
        "EXPORT_REMOTE_COLLECTIONS": "Export remote collections",
        "EXPORT_SUBSCRIPTIONS": "Export POS terminal subscriptions",
        "EXPORT_SIMS": "Export SIMs",
        "EXPORT_ORGANIZATIONS": "Export organizations",
        "EXPORT_CONTRACTS": "Export merchant account contracts",
        "EXPORT_CONTRACTS_ACCESSES": "Export merchant accounts",
        "EXPORT_MONETICS_USERS": "Export monetics users",
        "EXPORT_HISTORY": "Export logs",
        "PUSH_PAYMENT_EXPORT": "Export rules",
        "EXPORT_POS_TERMINAL_TRANSACTIONS": "Export POS terminal transactions",
        "EXPORT_POS_TERMINAL_REMOTE_COLLECTIONS": "Export POS terminal remote collections",
        "EXPORT_PAYLUDD_POS_TERMINALS": "Export Payludd POS terminals",
        "COMPANY_INFOS_READ": "Fetch company information",
        "SUBSCRIPTION_PLAN_READ": "Read details",
        "SUBSCRIPTION_PLAN_LIST_CLIENT_PLANS": "List subscription plans of clients",
        "SUBSCRIPTION_PLAN_LIST_PROVIDER_PLANS": "List subscription plans of provider",
        "SUBSCRIPTION_PLAN_LIST_ALLOWED_CLIENTS_FOR_CLIENT_PLAN": "List allowed clients",
        "SUBSCRIPTION_PLAN_CREATE": "Create",
        "SUBSCRIPTION_PLAN_ADD_CLIENT": "Add a client to a subscription plan",
        "SUBSCRIPTION_PLAN_DELETE_CLIENT": "Remove a client from a subscription plan",
        "SUBSCRIPTION_PLAN_UPDATE": "Update",
        "ORGANIZATION_READ": "Read details",
        "ORGANIZATION_LIST": "List",
        "ORGANIZATION_CREATE": "Create an organization",
        "ORGANIZATION_CREATE_CLIENT_ORGANIZATION": "Create a nested organization",
        "ORGANIZATION_UPDATE": "Update an organization",
        "ORGANIZATION_UPDATE_SHOULD_BLOCK_NEW_POS": "Block new POS",
        "ORGANIZATION_UPDATE_ALERT_POS": "Manage mail alerts",
        "ORGANIZATION_GET_ALERT_POS": "Read mail alerts",
        "ORGANIZATION_GET_ALERT_SIMS": "Read SIM alerts",
        "ORGANIZATION_UPDATE_ALERT_SIMS": "Manage SIM alerts",
        "CHANGE_ORGANIZATION_SIM_OFFER": "Manage SIM offers",
        "PAYMENT_LIST_TERMINAL_REMOTE_COLLECTIONS": "List POS terminal remote collections",
        "PAYMENT_LIST_TERMINAL_TRANSACTIONS": "List POS terminal transactions",
        "PAYMENT_LIST_REMOTE_COLLECTIONS": "List POS terminal estate remote collections",
        "PAYMENT_LIST_REMOTE_COLLECTION_TRANSACTIONS": "List transactions of a remote collection",
        "PAYMENT_READ_PLBS_DETAILS": "Read PLBS file details",
        "PAYMENT_LIST_REMOTE_COLLECTION_PLBS": "List PLBS files of a remote collection",
        "PAYMENT_SEND_REMOTE_COLLECTION_NOTIFICATION": "Send a remote collection notification",
        "PAYMENT_SEND_TRANSACTION_NOTIFICATION": "Send a transaction notification",
        "SIM_READ": "Read details",
        "SIM_LIST": "List",
        "SIM_PASS_ORDER": "Order",
        "SIM_CREATE_SUBSCRIPTION": "Add SIM cards to a client",
        "SIM_ACTIVATE": "Activate",
        "SIM_UPDATE": "Update",
        "SIM_GET_STATUS_FROM_ICCID": "Fetch SIM cards statuses",
        "SIM_PAYVIEW_OFFER_LIST": "List offers",
        "SIM_IMPORT_FROM_ORDER": "Import SIM cards from orderID",
        "SIM_ASSOCIATE": "Associate existing SIM cards to a customer",
        "SIM_SUSPEND": "Suspend",
        "SIM_REPLACE": "Replace",
        "SIM_TERMINATE": "Resiliate",
        "SIM_RESUME": "Resume a suspended SIM card",
        "SIM_IMPORT_CSV": "Import SIM cards from a CSV file",
        "SIM_REASSIGN": "Reassign / unassign",
        "UPGRADE_SIM_OFFER": "Modify offer",
        "GET_ORGANIZATION_SIM_OFFERS": "List offers",
        "MB_ADMIN": "Modify white label",
        "MB_PERSONALIZE": "Modify personalization",
        "GET_OFFERS_FOR_SIM": "List offers",
        "POS_TERMINAL_READ": "Read details",
        "POS_TERMINAL_LIST_EVENT_LOGS": "List connections",
        "POS_TERMINAL_CREATE": "Create manually",
        "POS_TERMINAL_UPDATE": "Update",
        "GET_GEOLOCATION": "Show geolocation",
        "USER_READ": "Read details",
        "USER_CREATE": "Create / Modify",
        "USER_ACTIVATE": "Activate",
        "USER_DEACTIVATE": "Deactivate",
        "USER_RESEND_ACTIVATION_MAIL": "Resend activation email",
        "USER_LIST": "List",
        "USER_REMOVE": "Delete",
        "USER_LOGIN_AS_USER": "Connect as",
        "LIST_REMOTE_DOWNLOADS": "List",
        "EXPORT_REMOTE_DOWNLOADS": "Export envelopes",
        "CSV_INSERT_POS_REMOTE_DOWNLOAD": "Create",
        "DELETE_REMOTE_DOWNLOADS": "Deprogram",
        "PUSH_PAYMENT_READ": "List partner organisations and notification rules",
        "PUSH_PAYMENT_UPDATE": "Modify the label",
        "PUSH_PAYMENT_DELETE": "Delete a notification rule",
        "PUSH_PAYMENT_IMPORT": "Create/Delete rules via CSV",
        "VISUALISE_POS_TERMINAL_STATUS_ON_GATEWAY": "View status on gateway",
        "MERCHANT_EXPORT_REMOTE_COLLECTIONS": "Export remote collections",
        "MERCHANT_EXPORT_GLOBAL_TRANSACTIONS": "Export transactions",
        "MERCHANT_PAYMENT_LIST_REMOTE_COLLECTIONS": "List remote collections",
        "MERCHANT_PAYMENT_LIST_REMOTE_COLLECTION_TRANSACTIONS": "List remote collections transactions",
        "MERCHANT_PAYMENT_SEND_REMOTE_COLLECTION_NOTIFICATION": "Send telecollection ticket",
        "MERCHANT_PAYMENT_LIST_GLOBAL_TRANSACTIONS": "List park transactions",
        "MERCHANT_PAYMENT_SEND_TRANSACTION_NOTIFICATION": "Send carrier ticket",
        "MERCHANT_PAYMENT_READ_MERCHANT_TICKET": "Display/Export merchant ticket",
        "MERCHANT_SHOP_MANAGEMENT": "Manage groups",
        "MERCHANT_SHOP_READ": "Display groups",
        "MERCHANT_POS_LABEL_UPDATE": "Update POS label",
        "ANDROID_MANAGE_PACKAGE": "Customize Android POS Terminal",
        "TRANSACTIONS_EMERGENCY_REMOTE": "Emergency remote collection",
        "LIST_HISTORY": "List",
        "SCHEDULED_EXPORT_MERCHANT_REMOTE_COLLECTIONS": "Manage remittances exports",
        "SCHEDULED_EXPORT_MERCHANT_TRANSACTIONS": "Manage transactions exports",
        "MERCHANT_EXPORT_PAYMENT_LIST_TRANSACTIONS_WITH_TIPS": "Export tips",
        "MERCHANT_PAYMENT_LIST_TRANSACTIONS_WITH_TIPS": "List tips",
        "MERCHANT_TRANSACTIONS_REFUND": "Refund"
    },
    "profile": {
        "PROFILE_ADMIN": "Administrator",
        "PROFILE_READ_ONLY": "Read only",
        "PROFILE_SIM_AND_TERMINAL_MANAGER": "Management POS-SIM",
        "PROFILE_HOTLINE": "Hotline"
    },
    "status": {
        "ACTIVE": "Activated",
        "INACTIVE": "Deactivated"
    },
    "toast": {
        "success": {
            "activate": "Successful reactivation of the user",
            "deactivate": "Successful deactivation of the user"
        },
        "error": {
            "activate": "User reactivation aborted",
            "deactivate": "User deactivation aborted"
        }
    },
    "tooltip": {
        "has_mfa": "Two-factor authentication"
    }
}